import { Grid } from "@mui/material";
import { Link, Stack, Typography } from "@financeable-com-au/financeable-ui";
import { ASSET_SEARCH_OPTIONS, searchableAssets } from "@/constants";
import { GlassesGuideFieldsProps } from "@/utils/interface";
import AssetManualFields from "./AssetManualFields";

/** The manual fields, the toggle into them, and the note shown when the lookup has no match. */
const GlassesGuideFields = ({
  asset,
  allValues,
  handle,
  isManualAssets,
  isGlassesGuideSearchable,
  getLocalAndLenderError,
  isDisableEdit,
}: GlassesGuideFieldsProps) => {
  const { _id: assetId, typeOfSale = "", searchVehicleLoader = false, isNVICAbsence = false } = asset;

  const isAssetTypeSearchable = searchableAssets.includes(allValues?.assetTypeValue);
  const showManualFields = isManualAssets || !isGlassesGuideSearchable || !isAssetTypeSearchable;

  return (
    <Stack style={{ margin: "0 0 20px 0" }}>
      {showManualFields && (
        <AssetManualFields
          assetId={assetId}
          allValues={allValues}
          handle={handle}
          getLocalAndLenderError={getLocalAndLenderError}
          searchVehicleLoader={searchVehicleLoader}
          typeOfSale={typeOfSale}
          isDisableEdit={isDisableEdit}
        />
      )}

      {/* A link cannot be disabled, so a broker who may not edit the application is not offered the switch at all. */}
      {isAssetTypeSearchable && !isDisableEdit && (
        <Stack direction="row" spacing={1} alignItems="baseline" flexWrap="wrap" sx={{ mt: 3 }}>
          {/* The broker is already in the manual fields, so there is nothing left for them to not find. */}
          {!isManualAssets && (
            <Typography level="body-sm" textColor="text.tertiary">
              {ASSET_SEARCH_OPTIONS.MANUAL_PROMPT}
            </Typography>
          )}
          <Link
            component="button"
            type="button"
            level="body-sm"
            underline="hover"
            onClick={handle.handleToggleAssetDetails}
          >
            {isManualAssets ? ASSET_SEARCH_OPTIONS.LOOKUP_TOGGLE : ASSET_SEARCH_OPTIONS.MANUAL_TOGGLE}
          </Link>
        </Stack>
      )}

      {isNVICAbsence && (
        <Grid item xs={12} mt={2} container direction="row">
          <Typography style={{ fontWeight: 600 }} level="body-md">
            Note: Vehicle search is not available for the selected vehicle. Please verify or You can enter the details
            manually.
          </Typography>
        </Grid>
      )}
    </Stack>
  );
};

export default GlassesGuideFields;
